import { render, staticRenderFns } from "./AccomodationPriceDiscount.vue?vue&type=template&id=3d76e23b&scoped=true&"
import script from "./AccomodationPriceDiscount.vue?vue&type=script&lang=js&"
export * from "./AccomodationPriceDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d76e23b",
  null
  
)

export default component.exports